var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSystemIsDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0638 0.585034C12.9319 0.405933 12.7229 0.299805 12.4998 0.299805H5.84983C5.46343 0.299805 5.14983 0.613403 5.14983 0.999805V2.80996L3.19475 0.854883C2.92183 0.581616 2.478 0.581616 2.20508 0.854883C1.93164 1.12832 1.93164 1.57129 2.20508 1.84473L5.14983 4.78965V9.3998C5.14983 9.78621 5.46343 10.0998 5.84983 10.0998H7.24983V16.3998C7.24983 16.7173 7.46345 16.9949 7.77039 17.0764C7.82986 17.0925 7.89036 17.0998 7.94983 17.0998C8.19661 17.0998 8.43074 16.9689 8.55754 16.7471L11.6665 11.3062L14.8051 14.4447C14.9418 14.5816 15.1207 14.6498 15.2998 14.6498C15.4791 14.6498 15.658 14.5816 15.7948 14.4447C16.0682 14.1713 16.0682 13.7283 15.7948 13.4549L12.3865 10.0467L14.1575 6.94707C14.2814 6.73037 14.2808 6.46428 14.155 6.24844C14.0301 6.03242 13.7995 5.8998 13.5498 5.8998H11.7022L13.168 1.20881C13.2345 0.995874 13.1957 0.764648 13.0638 0.585034ZM8.64983 13.764V9.3998C8.64983 9.0134 8.33623 8.6998 7.94983 8.6998H6.54983V6.18965L10.6408 10.2804L8.64983 13.764ZM12.3438 7.2998L11.3606 9.02041L6.54983 4.20996V1.6998H11.5476L10.0818 6.3908C10.0156 6.60322 10.0541 6.83496 10.186 7.01423C10.318 7.19334 10.527 7.2998 10.7498 7.2998H12.3438Z",
    fill: "#E7A846"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.8,
    height: 16.8,
    fill: "white",
    transform: "translate(0.600098 0.299805)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemIsDown);
export default __webpack_public_path__ + "static/media/system-is-down.faa0f49ce9e474e5b686ecaed75de02d.svg";
export { ForwardRef as ReactComponent };